<p *ngIf="_text" class="f-color-red" [class.hide]="_hide">{{ _text }}</p>
